module.exports = __webpack_public_path__ + "static/media/welcome-edit.f9975f2e.png";